import React, { useEffect } from 'react';
import { BaseComponentProps } from '@/pages/benchmark/types/commom';
import classNames from 'classnames';
import './index.scss';
import RenderConfigText from '@home/components/RenderConfigText';

export interface IHomeFooterProps extends BaseComponentProps {
  textEn: string;
  textCn: string;
  urls: string[];
  paddingBottom?: number;
}

export default function HomeFooter(props: IHomeFooterProps) {
  const {
    style,
    className,
    textEn = 'If you have any questions or suggestions regarding this page, please contact waowu@tencent.com.',
    textCn = '如有问题，请联系 waowu@tencent.com',
    urls = [],
    paddingBottom = 40,
  } = props || {};

  useEffect(() => {
    // 匹配传入路径，需要单独扩展外部容器的padding值
    const currentUrl = location.href;
    let hasUrl = false;
    urls?.forEach((url) => {
      if (currentUrl.includes(url)) {
        hasUrl = true;
      }
    });
    if (hasUrl) {
      const contextboxDom = document.querySelector('.dbh-studio-contextbox');
      if (contextboxDom) {
        contextboxDom.style.paddingBottom = `${paddingBottom}px`;
      }
    }
  }, [paddingBottom]);

  return (
    <div
      className={classNames('dbh-studio-foolter-container', className)}
      style={style}
    >
      <RenderConfigText contentEn={textEn} contentCn={textCn} />
    </div>
  );
}
